import React from 'react';
import branch from 'branch-sdk';

import { branchApiKey } from '../verticalConfigs';

/**
 * Parses a deep link path and extracts senderId (if present)
 * and the actual route path to navigate to.
 *
 * @param {string} path
 * @returns {{ senderId: string | null, actualPath: string } | null}
 */
function parseDeepLink(path) {
  if (!path || typeof path !== 'string') return null;

  const parts = path.split('/');
  let senderId = null;
  let actualPathParts = parts;

  const senderIdIndex = parts.indexOf('sender_id');
  if (senderIdIndex !== -1 && parts.length > senderIdIndex + 1) {
    senderId = parts[senderIdIndex + 1];
    actualPathParts = parts.slice(senderIdIndex + 2);
  }

  if (actualPathParts.length === 0) return null;

  const actualPath = `/${actualPathParts.join('/')}`;
  return { senderId, actualPath };
}

export function withBranchDeepLink(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        branchData: null,
        branchLoaded: false,
        branchError: null,
      };
    }

    componentDidMount() {
      if (branchApiKey()) {
        branch.init(branchApiKey(), (err, res) => {
          if (err) {
            this.setState({ branchError: err, branchLoaded: true });
            return;
          }

          if (res && res.data_parsed?.['+clicked_branch_link']) {
            const { actualPath, senderId } = parseDeepLink(res.data_parsed.$deeplink_path) || {};

            this.setState({
              branchData: {
                clickedBranchLink: true,
                path: actualPath,
                senderId,
                dataParsed: res.data_parsed,
              },
              branchLoaded: true,
            });
          } else {
            this.setState({ branchData: { clickedBranchLink: false }, branchLoaded: true });
          }
        });
      }
    }

    clearBranchData = () => {
      this.setState({ branchData: null });
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          branchData={this.state.branchData}
          branchLoaded={this.state.branchLoaded}
          branchError={this.state.branchError}
          clearBranchData={this.clearBranchData}
        />
      );
    }
  };
}
